import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "app"
};
const _hoisted_2 = {
  key: 0,
  class: "flex-1 overflow-hidden h-full"
};
const _hoisted_3 = {
  class: "app-middle"
};
const _hoisted_4 = {
  class: "app-footer"
};
const _hoisted_5 = {
  class: "nav"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src", "alt"];
import VideoFull from "@/components/VideoFull/index.vue";
import AppTitle from "@/components/AppTitle/index.vue";
import audioBg from "@/assets/audio/bg.mp3";
import AppDatas from "@/components/AppDatas/index.vue";
import "@/utils/hall/hall";
import { mapStore } from "@/store/map";
import { openCenteredWindow } from "@/utils/tool/index";

import { inject, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'mobile',
  setup(__props) {
    const {
      title,
      onCoyp
    } = inject("app-store");
    const {
      byname,
      level
    } = mapStore();
    const Route = useRoute();
    const Router = useRouter();

    /* 👇 footer 👇 */
    const videoShow = ref(false);
    const videoSrc = ref("");
    const navActiveIndex = ref(4);
    const navList = ref([{
      icon: "/nav/nav01.png",
      name: "应急救护",
      video: require("@/assets/video/video01.mp4")
    }, {
      icon: "/nav/nav02.png",
      name: "反诈宣传",
      video: require("@/assets/video/video02.mp4")
    }, {
      icon: "/nav/nav03.png",
      name: "便民服务",
      video: require("@/assets/video/video03.mp4")
    }, {
      icon: "/nav/nav04.png",
      name: "ETC服务",
      video: require("@/assets/video/video04.mp4")
    }, {
      icon: "/nav/nav05.png",
      name: "赣韵地图",
      url: "/home"
    }]);
    const onNavListItem = (navItem, itemIndex) => {
      if (navItem?.url) {
        Router.push(navItem.url);
        videoShow.value = false;
        navActiveIndex.value = itemIndex;
      } else if (navItem?.video) {
        videoShow.value = true;
        videoSrc.value = navItem.video;
        navActiveIndex.value = itemIndex;
      } else {
        ElMessage({
          type: "warning",
          message: "即将上线，敬请期待！"
        });
      }
    };
    /* 👆 footer 👆 */

    onMounted(() => {
      let root = document.documentElement;
      root.style.setProperty("--design-width", "1080px");
      root.style.setProperty("--design-height", "1920px");
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(AppTitle, {
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(0))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(title)), 1)]),
        _: 1
      }), _unref(videoShow) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(VideoFull, {
        src: _unref(videoSrc)
      }, null, 8, ["src"])])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(AppDatas), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view)])], 64)), _createElementVNode("footer", _hoisted_4, [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "nav-item",
          onClick: $event => onNavListItem(item, index),
          style: _normalizeStyle(`background-image: url(${require(`@/assets/images/nav/${_unref(navActiveIndex) === index ? 'inactive' : 'active'}.png`)});`)
        }, [_createElementVNode("img", {
          src: require(`@/assets/images${item.icon}`),
          alt: item.icon
        }, null, 8, _hoisted_7), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 12, _hoisted_6);
      }), 256))])]), _createElementVNode("div", {
        class: "copy",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(onCoyp) && _unref(onCoyp)(...args))
      }, " 赣ICP备2025063872号-1 ")]);
    };
  }
};